var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamsFlat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3204 11.1627H30.586C31.367 11.1627 32 11.7958 32 12.5767V20.1056C32 22.9756 29.6734 25.3023 26.8034 25.3023H26.7787C23.9087 25.3027 21.5817 22.9765 21.5814 20.1063V11.9018C21.5813 11.8048 21.6004 11.7087 21.6375 11.619C21.6746 11.5293 21.7291 11.4478 21.7977 11.3791C21.8663 11.3105 21.9478 11.2561 22.0375 11.2189C22.1272 11.1818 22.2233 11.1627 22.3204 11.1627Z",
    fill: "#5059C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.907 9.6745C29.7565 9.6745 31.2559 8.17515 31.2559 6.32562C31.2559 4.47609 29.7565 2.97675 27.907 2.97675C26.0575 2.97675 24.5581 4.47609 24.5581 6.32562C24.5581 8.17515 26.0575 9.6745 27.907 9.6745Z",
    fill: "#5059C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4884 9.6745C20.1599 9.6745 22.3256 7.50879 22.3256 4.83725C22.3256 2.16571 20.1599 0 17.4884 0C14.8168 0 12.6511 2.16571 12.6511 4.83725C12.6511 7.50879 14.8168 9.6745 17.4884 9.6745Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9382 11.1627H10.2944C9.52273 11.1818 8.91236 11.8222 8.93023 12.5938V21.181C8.82248 25.8115 12.4859 29.6541 17.1162 29.7675C21.7466 29.6541 25.41 25.8115 25.3024 21.181V12.5938C25.3202 11.8222 24.7099 11.1818 23.9382 11.1627Z",
    fill: "#7B83EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.8605 11.1627V23.1962C17.8587 23.4661 17.7772 23.7295 17.6263 23.9532C17.4754 24.177 17.2617 24.3512 17.0121 24.454C16.8496 24.5227 16.675 24.5581 16.4986 24.5581H9.58501C9.48826 24.3125 9.39901 24.0668 9.32451 23.814C9.064 22.96 8.9311 22.0723 8.93013 21.1795V12.5916C8.91226 11.8212 9.52163 11.1818 10.292 11.1628L17.8605 11.1627Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.1163 11.1627V23.9405C17.1163 24.1168 17.0809 24.2915 17.0121 24.454C16.9094 24.7036 16.7352 24.9172 16.5114 25.0682C16.2876 25.2191 16.0243 25.3006 15.7544 25.3023H9.935C9.8085 25.0567 9.68938 24.8111 9.58525 24.5581C9.48521 24.3149 9.39825 24.0665 9.32475 23.814C9.06424 22.96 8.93135 22.0723 8.93038 21.1795V12.5916C8.9125 11.8212 9.52188 11.1818 10.2923 11.1628L17.1163 11.1627Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.1163 11.1627V22.4521C17.1106 23.2018 16.5043 23.8083 15.7544 23.814H9.32463C9.06412 22.96 8.93122 22.0723 8.93025 21.1795V12.5916C8.91238 11.8212 9.52175 11.1818 10.2921 11.1628L17.1163 11.1627Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.3721 11.1627V22.4521C16.3664 23.2018 15.76 23.8083 15.0103 23.814H9.32463C9.06412 22.96 8.93122 22.0723 8.93025 21.1795V12.5916C8.91238 11.8212 9.52175 11.1818 10.2921 11.1628L16.3721 11.1627Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.8605 7.31537V9.65949C17.734 9.66699 17.6149 9.67449 17.4884 9.67449C17.3619 9.67449 17.2428 9.66699 17.1163 9.65949C16.8651 9.64282 16.616 9.60299 16.3721 9.54049C15.6292 9.36454 14.9385 9.01524 14.3564 8.52115C13.7744 8.02707 13.3175 7.40223 13.0233 6.69774C12.9205 6.45775 12.8408 6.20855 12.7851 5.95349H16.4986C17.2495 5.95637 17.8576 6.56437 17.8605 7.31537Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.1163 8.0595V9.6595C16.8651 9.64284 16.616 9.603 16.3721 9.5405C15.6292 9.36453 14.9385 9.01522 14.3565 8.52114C13.7745 8.02706 13.3176 7.40223 13.0234 6.69775H15.7544C16.5054 6.7005 17.1134 7.30863 17.1163 8.0595Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.1163 8.0595V9.6595C16.8651 9.64284 16.616 9.603 16.3721 9.5405C15.6292 9.36453 14.9385 9.01522 14.3565 8.52114C13.7745 8.02706 13.3176 7.40223 13.0234 6.69775H15.7544C16.5054 6.7005 17.1134 7.30863 17.1163 8.0595Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.3721 8.05951V9.54051C15.6292 9.36454 14.9384 9.01522 14.3564 8.52111C13.7743 8.02701 13.3175 7.40215 13.0233 6.69763H15.0103C15.7613 6.70051 16.3693 7.30863 16.3721 8.05951Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36413 6.69763H15.0079C15.7614 6.69763 16.3721 7.30838 16.3721 8.06176V21.7056C16.3721 22.459 15.7614 23.0698 15.008 23.0698H1.36413C0.61075 23.0698 0 22.459 0 21.7056V8.06188C0 7.30826 0.61075 6.69763 1.36413 6.69763Z",
    fill: "url(#paint0_linear_50_63)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.776 11.8906H9.04851V19.3176H7.31088V11.8906H4.59613V10.4499H11.776V11.8906Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_63",
    x1: 284.417,
    y1: -99.8858,
    x2: 1352.81,
    y2: 1750.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsFlat);
export default __webpack_public_path__ + "static/media/teams_flat.6aa5df247cd36d2318f9154db2d4e786.svg";
export { ForwardRef as ReactComponent };